import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileArrowDown } from "@fortawesome/free-solid-svg-icons";
import TermsEn from "../../assets/files/masarTermsEn.pdf";
import TermsAr from "../../assets/files/masarTermsAr.pdf";

export function TermsConditionsAr() {
    return (
        <div className="container">
            <h4 className="text-center c-darkBeige">اتفاقية الشروط والأحكام</h4>

            <h6 className="c-darkOrange"><strong>مقدمة</strong></h6>
            <p><strong> مرحبًا بكم في موقع "مسار التميز" </strong>(<a rel="noreferrer" target="_new" href="https://www.masar-t.com.sa">https://www.masar-t.com.sa</a>) التابعة لشركة مسار التميز لتقنية المعلومات<br />
                ٢٨٨٩ طريق الأمير سعد بن عبدالرحمن الأول، ٨٤٤٤</p>

            <h6 className="c-darkOrange"><strong>1&ndash; قبول الشروط</strong></h6>

            <p>باستخدامك لموقع "مسار التميز"، فإنك توافق على الالتزام بهذه الشروط والأحكام، وكذلك سياسة الخصوصية الخاصة بنا. إذا كنت لا توافق على أي جزء من هذه الشروط، يرجى التوقف عن استخدام الموقع.</p>

            <h6 className="c-darkOrange"><strong>2&ndash; وصف الخدمة</strong></h6>
            <p>"مسار التميز" يقدم الخدمات والحلول الإعلامية، النشر والتوزيع للكتب، وكذلك تصميم وبناء وإدارة المواقع وصفحات السوشيال ميديا.</p>
            <h6 className="c-darkOrange"><strong>3&ndash; إنشاء الحساب</strong></h6>

            <p>لاستخدام بعض خدماتنا، يجب عليك إنشاء حساب. يتطلب ذلك تقديم معلومات شخصية مثل الاسم، رقم الجوال، البريد الإلكتروني، العنوان، وتاريخ الميلاد. أنت مسؤول عن الحفاظ على سرية بيانات تسجيل الدخول الخاصة بك.</p>

            <h6 className="c-darkOrange"><strong>4&ndash; جمع المعلومات الشخصية</strong></h6>

            <p>نحن نقوم بجمع وتخزين المعلومات الشخصية التي تقدمها لنا، بما في ذلك الاسم، رقم الجوال، البريد الإلكتروني، العنوان، وتاريخ الميلاد. نستخدم هذه المعلومات لتحسين خدماتنا وللتواصل معك بشأن طلباتك واستفساراتك.</p>

            <h6 className="c-darkOrange"><strong>5&ndash; القيود والشروط الخاصة بالاستخدام</strong></h6>

            <p>لا يوجد لدينا شروط خاصة للاستخدام غير أن تكون مسؤولًا قانونيًا أمام الجهات المختصة أو من ينوب عنك.</p>

            <h6 className="c-darkOrange"><strong>6&ndash; الإعلانات</strong></h6>
            <p>حاليًا، لا يحتوي موقعنا على أي إعلانات.</p>

            <h6 className="c-darkOrange"><strong>7&ndash; سياسة استرداد الأموال والإلغاء</strong></h6>
            <p>يمكنك استرداد الأموال في حالة عدم الاتفاق وعدم وجود بديل آخر كإضافتهم لحسابك للعمليات المستقبلية.</p>

            <h6 className="c-darkOrange"><strong>8&ndash; تحديث المحتوى والخدمات</strong></h6>
            <p>نحتفظ بالحق في تحديث وتغيير المحتوى والخدمات على موقعنا بشكل دوري.</p>

            <h6 className="c-darkOrange"><strong>9&ndash; الالتزامات القانونية</strong></h6>
            <p>يلتزم المستخدم بالآداب العامة وخلو المعاملات من المحرمات شرعًا طبقا للدين الإسلامي، وكذلك خلوها من كل ما يتعارض مع القوانين المحلية.</p>

            <h6 className="c-darkOrange"><strong>10&ndash; الموافقة على الشروط والأحكام</strong></h6>
            <p>بموافقتك على هذه الشروط والأحكام، فإنك توافق أيضًا على سياسة الخصوصية الخاصة بنا.
                <br />
                يرجى مراجعة هذه المسودة وإبلاغي بأي تعديلات أو إضافات ترغب فيها.</p>

            <p className="text-end">إدارة منصة مسار لتقنية المعلومات
                <br />
                <a href="/ar/contact-us" className="btn-masar text-black btn-med-gray text-decoration-none p-2">تواصل معنا</a>

                <a href={TermsAr} target="_blank" rel="noreferrer" className="btn-masar btn-dark-orange text-decoration-none px-2 p-0 float-end mx-2">
                    تحميل <FontAwesomeIcon icon={faFileArrowDown} />
                </a>
            </p>

        </div>
    )

}

export function TermsConditionsEn() {
    return (
        <div className="container">
            <h4 className="text-center c-darkBeige">Terms and Conditions Agreement</h4>

            <h6 className="c-darkOrange"><strong>Introduction</strong></h6>
            <p><strong>Welcome to the "Masar Al-Tamayoz" website</strong> (<a rel="noreferrer" target="_new" href="https://www.masar-t.com.sa">https://www.masar-t.com.sa</a>) owned by Masar Al-Tamayoz Information Technology Company<br />
                2889 Prince Saad Bin Abdulrahman Al-Awwal Road, 8444</p>

            <h6 className="c-darkOrange"><strong>1&ndash; Acceptance of Terms</strong></h6>

            <p>By using the "Masar Al-Tamayoz" website, you agree to abide by these terms and conditions, as well as our privacy policy. If you do not agree to any part of these terms, please stop using the website.</p>

            <h6 className="c-darkOrange"><strong>2&ndash; Description of Service</strong></h6>
            <p>"Masar Al-Tamayoz" provides media solutions, book publishing and distribution, as well as website and social media page design, development, and management.</p>
            <h6 className="c-darkOrange"><strong>3&ndash; Account Creation</strong></h6>

            <p>To use some of our services, you must create an account. This requires providing personal information such as your name, mobile number, email address, address, and date of birth. You are responsible for maintaining the confidentiality of your login credentials.</p>

            <h6 className="c-darkOrange"><strong>4&ndash; Collection of Personal Information</strong></h6>

            <p>We collect and store the personal information you provide to us, including your name, mobile number, email address, address, and date of birth. We use this information to improve our services and to communicate with you regarding your requests and inquiries.</p>

            <h6 className="c-darkOrange"><strong>5&ndash; Usage Restrictions and Conditions</strong></h6>

            <p>We do not have specific usage conditions other than being legally responsible before the competent authorities or their representatives.</p>

            <h6 className="c-darkOrange"><strong>6&ndash; Advertisements</strong></h6>
            <p>Currently, our website does not contain any advertisements.</p>

            <h6 className="c-darkOrange"><strong>7&ndash; Refund and Cancellation Policy</strong></h6>
            <p>You can request a refund in case of disagreement and if no alternative is provided, such as crediting your account for future transactions.</p>

            <h6 className="c-darkOrange"><strong>8&ndash; Content and Service Updates</strong></h6>
            <p>We reserve the right to periodically update and change the content and services on our website.</p>

            <h6 className="c-darkOrange"><strong>9&ndash; Legal Obligations</strong></h6>
            <p>The user is obligated to adhere to public morals and ensure that transactions are free from religiously prohibited elements according to Islamic law, as well as anything that conflicts with local laws.</p>

            <h6 className="c-darkOrange"><strong>10&ndash; Acceptance of Terms and Conditions</strong></h6>
            <p>By agreeing to these terms and conditions, you also agree to our privacy policy.
                <br />
                Please review this draft and inform us of any modifications or additions you wish to make.</p>

            <p className="text-end">Masar Information Technology Platform Management
                <br />
                <a href="/en/contact-us" className="btn-masar text-black btn-med-gray text-decoration-none p-2">Contact Us</a>

                <a href={TermsEn} target="_blank" rel="noreferrer" className="btn-masar btn-dark-orange text-decoration-none px-2 p-0 float-end mx-2">
                    Download <FontAwesomeIcon icon={faFileArrowDown} />
                </a>
            </p>

        </div>
    )

}